var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor send-email" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.createEventStartTitle"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper date" },
        [
          _c(
            "a-radio-group",
            {
              staticClass: "radio-btns",
              model: {
                value: _vm.clone.selectType,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "selectType", $$v)
                },
                expression: "clone.selectType",
              },
            },
            [
              _c(
                "a-radio",
                { staticClass: "radio-btn", attrs: { value: "now" } },
                [_vm._v(_vm._s(_vm.$t("chatbotv2.createEventNow")))]
              ),
              _vm._v(" "),
              _c(
                "a-radio",
                {
                  staticClass: "radio-btn",
                  staticStyle: { margin: "10px 0" },
                  attrs: { value: "after" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.afterSelectTimeValue,
                        expression: "afterSelectTimeValue",
                      },
                    ],
                    staticClass: "input-number",
                    attrs: {
                      type: "number",
                      disabled: _vm.clone.selectType !== "after",
                    },
                    domProps: { value: _vm.afterSelectTimeValue },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.afterSelectTimeValue = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "170px" },
                      attrs: {
                        "show-search": "",
                        disabled: _vm.clone.selectType !== "after",
                      },
                      on: { change: _vm.changeRepeat },
                      model: {
                        value: _vm.afterSelectTime,
                        callback: function ($$v) {
                          _vm.afterSelectTime = $$v
                        },
                        expression: "afterSelectTime",
                      },
                    },
                    _vm._l(_vm.timeOptions, function (repeatTime, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: repeatTime.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(repeatTime.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.createEventAfter"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "show-search": "",
                        disabled: _vm.clone.selectType !== "after",
                      },
                      on: { change: _vm.changeRepeat },
                      model: {
                        value: _vm.afterSelectDate,
                        callback: function ($$v) {
                          _vm.afterSelectDate = $$v
                        },
                        expression: "afterSelectDate",
                      },
                    },
                    _vm._l(_vm.dateOptions, function (repeatTime, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: repeatTime.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(repeatTime.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-radio",
                { staticClass: "radio-btn", attrs: { value: "before" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.beforeSelectTimeValue,
                        expression: "beforeSelectTimeValue",
                      },
                    ],
                    staticClass: "input-number",
                    attrs: {
                      type: "number",
                      disabled: _vm.clone.selectType !== "before",
                    },
                    domProps: { value: _vm.beforeSelectTimeValue },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.beforeSelectTimeValue = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "170px" },
                      attrs: {
                        "show-search": "",
                        disabled: _vm.clone.selectType !== "before",
                      },
                      on: { change: _vm.changeRepeat },
                      model: {
                        value: _vm.beforeSelectTime,
                        callback: function ($$v) {
                          _vm.beforeSelectTime = $$v
                        },
                        expression: "beforeSelectTime",
                      },
                    },
                    _vm._l(_vm.timeOptions, function (repeatTime, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: repeatTime.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(repeatTime.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.createEventBefore"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "show-search": "",
                        disabled: _vm.clone.selectType !== "before",
                      },
                      on: { change: _vm.changeRepeat },
                      model: {
                        value: _vm.beforeSelectDate,
                        callback: function ($$v) {
                          _vm.beforeSelectDate = $$v
                        },
                        expression: "beforeSelectDate",
                      },
                    },
                    _vm._l(_vm.dateOptions, function (repeatTime, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: repeatTime.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(repeatTime.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.createEventDurationTitle"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clone.eventTime,
                expression: "clone.eventTime",
              },
            ],
            staticClass: "input-number",
            attrs: { type: "number" },
            domProps: { value: _vm.clone.eventTime },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.clone, "eventTime", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "170px" },
              attrs: { "show-search": "" },
              on: { change: _vm.changeRepeat },
              model: {
                value: _vm.clone.eventTimeType,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "eventTimeType", $$v)
                },
                expression: "clone.eventTimeType",
              },
            },
            _vm._l(_vm.timeOptions, function (repeatTime, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: repeatTime.value } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(repeatTime.label) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.createEventSummaryTitle"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("chatbotv2.createEventSummaryPlaceholder"),
              "show-attributes": true,
              "show-emoji": false,
            },
            model: {
              value: _vm.clone.summary,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "summary", $$v)
              },
              expression: "clone.summary",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.createEventDescriptionTitle"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t(
                "chatbotv2.createEventDescriptionPlaceholder"
              ),
              "show-attributes": true,
              "show-emoji": false,
            },
            model: {
              value: _vm.clone.description,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "description", $$v)
              },
              expression: "clone.description",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createEventAgentsTitle"))),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { "show-search": "" },
            model: {
              value: _vm.clone.selectedUser,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "selectedUser", $$v)
              },
              expression: "clone.selectedUser",
            },
          },
          _vm._l(_vm.users, function (user, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: user._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(user.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createEventCalendarsTitle"))),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { "show-search": "" },
            model: {
              value: _vm.clone.selectUserCalendar,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "selectUserCalendar", $$v)
              },
              expression: "clone.selectUserCalendar",
            },
          },
          _vm._l(_vm.userCalendars, function (user, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: user._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(user.summary) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createEventOtherAgentsTitle"))),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { "show-search": "", mode: "tags" },
            model: {
              value: _vm.clone.refUsers,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "refUsers", $$v)
              },
              expression: "clone.refUsers",
            },
          },
          _vm._l(_vm.users, function (user, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: user._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(user.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }